module.exports = __webpack_public_path__ + "assets/img/quiz_noall_right.9129b49a.png";